<template>
    <b-modal
        :ref="modalRef"
        id="modalRef"
        title-tag="h2"
        :title="`Email ` + (estimate.name || `Estimate #` + estimate.index)"
        lazy
        footer-class="d-flex justify-content-between"
    >
        <b-form-group label-for="to" label="To:" label-cols="4">
            <recepient-email
                v-model="selectedReceivers"
                :client="client"
                @input="value => handleRecipientChange(value, editableDivId)"
            ></recepient-email>
        </b-form-group>

        <b-form-group label-for="subject" label="Subject:" label-cols="4">
            <b-form-input
                id="subject"
                v-model="subject"
                placeholder="Subject (optional)"
                name="subject"
            ></b-form-input>
        </b-form-group>

        <b-form-group label-for="message" label="Message:" label-cols="4">
            <editable
                :id="editableDivId"
                ref="editable"
                :value.sync="message"
            ></editable>
        </b-form-group>

        <b-form-group
            label-for="include_declined"
            label="Declined Items:"
            label-cols="4"
            v-if="isEstimateHasDeclinedItems"
        >
            <b-form-checkbox
                id="include_declined"
                v-model="includeDeclined"
                name="include_declined"
                plain
                class="col-form-label"
            >
                <span class="fw-normal">{{
                    TEXT_INCLUDE_DECLINED_ITEMS_ESTIMATE
                }}</span>
            </b-form-checkbox>
        </b-form-group>

        <template v-slot:modal-footer>
            <modal-footer
                :is-loading="isLoading"
                ok-title="Send"
                @ok-action="send"
                @cancel-action="close"
            />
        </template>
    </b-modal>
</template>
<script type="text/javascript">
import { forEach, map, uniq, isNil } from "lodash";
import Email from "@/services/email";
import CEMAIL from "@/constants/email";
import EmailMixins from "@/mixins/email";
import BillingEstimateServices from "@/services/billing/billing-estimate.js";
import { TEXT_INCLUDE_DECLINED_ITEMS_ESTIMATE } from "@/constants/billings.js";

export default {
    components: {
        recepientEmail: () =>
            import("@/components/commons/recipients-email.vue"),
        modalFooter: () => import("@/components/elements/modal-footer"),
        editable: () => import("@/components/elements/editable")
    },
    mixins: [EmailMixins],
    props: {
        modalRef: {
            type: String,
            required: true
        },
        estimate: {
            type: Object,
            default() {
                return {};
            }
        },
        client: {
            default: null
        }
    },
    data() {
        return {
            selectedReceiver: null,
            selectedReceivers: [],
            subject: null,
            message: null,
            recipientList: [],
            receiverNames: "",
            isLoading: false,
            includeDeclined: false,
            isEstimateHasDeclinedItems: false,
            TEXT_INCLUDE_DECLINED_ITEMS_ESTIMATE
        };
    },
    computed: {
        isOkDisabled() {
            return (
                this.message == null ||
                this.message == "" ||
                this.selectedReceivers.length < 1
            );
        },
        editableDivId() {
            return "email-message";
        }
    },
    methods: {
        async open() {
            this.$emit("show-loading", true);
            await this.checkEstimateHasDeclinedItem();
            this.$refs[this.modalRef].show();
            this.$nextTick(() => {
                this.$emit("show-loading", false);
                this.getEmailTemplate();
            });
        },
        async checkEstimateHasDeclinedItem() {
            if (this.estimate) {
                return BillingEstimateServices.getDeclinedCount(
                    this.estimate.id
                ).then(response => {
                    if (!isNil(response)) {
                        if (Number(response) > 0) {
                            this.isEstimateHasDeclinedItems = true;
                            return;
                        }
                    }
                    this.isEstimateHasDeclinedItems = false;
                    return;
                });
            }
        },
        getEmailTemplate() {
            let patientIds = [];
            if (
                this.estimate &&
                this.estimate.active_estimate_items?.length > 0
            ) {
                patientIds = uniq(
                    map(this.estimate.active_estimate_items, function (items) {
                        return items.patient_id;
                    })
                );
            }
            let params = {
                business_id: this._setting.business.id,
                user_id: this.$root.currentActor.id,
                email_type: CEMAIL.TYPE.ESTIMATE,
                client_id: this.client ? this.client.id : "",
                estimate_ids: [this.estimate.id],
                patient_id: patientIds.length > 0 ? patientIds : null
            };

            Email.renderEmailMessage(params).then(response => {
                this.setDetails(response.resources.message);
            });
        },
        setDetails(defaults) {
            let self = this;

            this.subject = defaults.subject;
            this.message = self.setNamesElement(defaults.message);

            setTimeout(function () {
                self.handleRecipientChange(
                    self.selectedReceivers,
                    self.editableDivId
                );
            }, 300);
        },
        async send() {
            let valid = await this.$validator.validateAll();

            if (!valid || this.isOkDisabled) {
                return false;
            }

            this.isLoading = true;

            let params = {
                estimate_id: this.estimate.id,
                timestamp: this._now().toFormat("X"),
                is_estimate: 1,
                email_type: CEMAIL.TYPE.ESTIMATE,
                first_name: this.receiverNames,
                last_name: "",
                subject: this.subject,
                message: this.message,
                to: [],
                include_declined: this.includeDeclined
            };

            if (this.selectedReceivers.length > 0) {
                forEach(this.selectedReceivers, function (element) {
                    params.to.push(element.to_id);
                });
            } else {
                return null;
            }

            BillingEstimateServices.sendEmail(params)
                .then(response => {
                    if (response.code == 200) {
                        this._message(response.message);
                    } else {
                        this._message(response.message, "danger");
                    }

                    this.close();
                })
                .catch(error => {
                    this._message("Error : Unable to email estimate", "danger");
                    this.close();
                    console.error(error);
                });
        },
        close() {
            this.isLoading = false;
            this.$refs[this.modalRef].hide();
        }
    }
};
</script>
